import ApiRequest from "../utils/ApiRequest";
import { bulkUploadModel } from "../utils/bulkUploadModel";

export default class Publisher {
  static getAll = async () => {
    return await ApiRequest.set("v1/publishers/getall", "GET");
  }

  static getById = async (id) => {
    return await ApiRequest.set(`v1/publishers/getbyid/${id}`, "GET");
  }

  static getAllWithPagination = async (limit, page, keyword) => {
    return await ApiRequest.set(`v1/publishers/admin/get-with-pagination?page=${page}&limit=${limit}&keyword=${keyword}`, "GET")
  }

  static create = async (body) => {
    return await ApiRequest.set("v1/publishers/create", "POST", body);
  }

  static edit = async (id, body) => {
    return await ApiRequest.set(`v1/publishers/update/${id}`, "PUT", body);
  }

  static delete = async (id) => {
    return await ApiRequest.set(`v1/publishers/${id}`, "DELETE");
  }

  static bulkUpload = async (file, dryRun = false) => {
    return await bulkUploadModel('v1/publishers/').bulkUpload(file, dryRun);
  };

  static downloadTemplate = async () => {
    return await bulkUploadModel('v1/publishers/').downloadTemplate();
  };
}
